export default {"src":"/_next/static/media/notif-empty.09967006.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};